// extracted by mini-css-extract-plugin
export default {"commentContainer":"HomeworkAssign_commentContainer__yWtR-","commentTitle":"HomeworkAssign_commentTitle__01+Ll"};